import React from 'react';

export type StatusIconVariant = 'warning' | 'error' | 'success' | 'loading';

interface StatusIconProps {
  variant: StatusIconVariant;
  className?: string;
}

export function StatusIcon({ variant, className = '' }: StatusIconProps) {
  const iconClass = `ev-status-icon ev-status-icon--${variant} ${className}`.trim();

  if (variant === 'loading') {
    return (
      <div className={iconClass} aria-hidden="true">
        <div className="ev-spinner" />
      </div>
    );
  }

  const paths: Record<Exclude<StatusIconVariant, 'loading'>, React.ReactNode> = {
    warning: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    error: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="M15 9l-6 6M9 9l6 6" strokeLinecap="round" />
      </svg>
    ),
    success: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <path d="M8 12l3 3 5-6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  };

  return <div className={iconClass}>{paths[variant]}</div>;
}
